import React from "react";
import cn from "classnames";

import "./Tooltip.scss";

export interface TooltipProps {
  children: React.ReactNode;
  coords?: {
    x: number;
    y: number;
  };
  horizontalShift?: boolean;
  verticalShift?: boolean;
  design?: "primary" | "secondary";
  multiline?: boolean;
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
  coords,
  horizontalShift,
  verticalShift,
  children,
  design = "secondary",
  multiline = false,
  className,
}) => {
  return (
    <div
      className={cn(`bpmTooltip ${design}`, { multiline: multiline }, className)}
      style={{
        position: coords ? "fixed" : "static",
        left: coords ? `${coords.x}px` : "auto",
        top: coords ? `${coords.y}px` : "auto",
        transform: `translateX(${horizontalShift ? -100 : 0}%) translateY(${
          verticalShift ? -100 : 0
        }%)`,
      }}
    >
      {children}
    </div>
  );
};
